export const FONT_FAMILY_STACK = [
  'Montserrat',
  'Open Sans',
  'Helvetica',
  'Arial',
  'sans-serif',
];

export const CHART_FONT_FAMILY = FONT_FAMILY_STACK.join(',');
